module.exports = __webpack_public_path__ + "static/media/om_eyeshape_upturned_grey.7f3f5649.png";